// extracted by mini-css-extract-plugin
export default {"image-box":"multipleChoiceForm_image-box__+ABQt","submit-box":"multipleChoiceForm_submit-box__mxQUj","header":"multipleChoiceForm_header__MAPRo"};